import React from "react";
import { Divider as ChakraDivider } from "@chakra-ui/react";

const Divider = () => {
  return (
    <ChakraDivider w="100%" borderBottomWidth="3px" color="black" mt="5" />
  );
};

export default Divider;
